import { FuelTableContainer } from 'pages/FuelManagement/FuelManagement.styled'
import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const FoodTableContainer = styled(FuelTableContainer)`
  width: 100%;
  height: 100%;
`
export const IngredientsList = styled.div`
  border: 1px solid ${tokens.border.hairline};
  padding: 1rem;
  border-radius: ${tokens.radius.card};
  height: 100%;
`

export const FoodDrawerOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 9999999;
`

export const FoodDrawer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 27rem;
  background: ${tokens.surface.raised};
  padding: 1.5rem;
  overflow-y: auto;
  z-index: 99999999;
  box-shadow: -16px 0 48px rgba(0, 0, 0, 0.5);
  @media (max-width: 500px) {
    width: 100%;
  }
`
